import { createRipple } from '@core/utils/miscUtils'

const RippleButton = ({ children, onClick, className = '', ...props }) => {
  const handleClick = (event) => {
    createRipple(event)
    if (onClick) onClick(event)
  }

  return (
    <button onClick={handleClick} className={`ripple-button ${className}`} {...props}>
      {children}
    </button>
  )
}

export default RippleButton
